import { render, staticRenderFns } from "./RVBChargingpointsByObjectType.vue?vue&type=template&id=2fb9e4d2&scoped=true"
import script from "./RVBChargingpointsByObjectType.vue?vue&type=script&lang=js"
export * from "./RVBChargingpointsByObjectType.vue?vue&type=script&lang=js"
import style0 from "./RVBChargingpointsByObjectType.vue?vue&type=style&index=0&id=2fb9e4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9e4d2",
  null
  
)

export default component.exports